import { Globals } from "../CoreApp/Globals.js";
import { PM_Handle_PicQueue } from "./PM_Handle_PicQueue.js";
import { getBase64Image } from "./getBase64Image.js";

export function PM_Image_Loaded() {
  var pRef = this["picmgr"];
  if (pRef == null) return;

  var picMgr = pRef.fPictureMgr;
  picMgr.fPicLoadCount--;
  var callBack = pRef.fCallBack;
  if (callBack?.canvasBufferCache && !this.canvasImgUrl) this.canvasImgUrl = getBase64Image(this);
  picMgr.AddPicture(pRef.fDirectory, pRef.fFileName, this);
  callBack?.ImageLoaded(pRef, Globals._bookRenderInfo == null);
  picMgr.LoadSubscribers(pRef.fDirectory, pRef.fFileName, callBack);

  picMgr.fPicActiveLoadCount--;
  PM_Handle_PicQueue(picMgr);
}
